import React, { useContext, useEffect, useState } from 'react';
import Heart from "../../../../Assets/Images/HEART.png";
import Soul from "../../../../Assets/Images/SOUL.png";
import Mind from "../../../../Assets/Images/MIND.png";
import Strength from "../../../../Assets/Images/STRENGTH.png";
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import { logItemsOverviewData } from '../../../../utils/itemsOverviewLogger';

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'HEART':
      return <img src={Heart} alt="Heart" className="logo" />;
    case 'SOUL':
      return <img src={Soul} alt="Soul" className="logo" />;
    case 'MIND':
      return <img src={Mind} alt="Mind" className="logo" />;
    case 'STRENGTH':
      return <img src={Strength} alt="Strength" className="logo" />;
    default:
      return null;
  }
};

const sideLabels = [
  { label: "ORIENTATION", bg: "#394554" },
  { label: "REWARDS", bg: "#666666" },
];

const QF_ItemFourthPage360 = ({ apiData, pageNumber }) => {
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';
  const { updateTablevaluesq2Page4 } = useGroupReportDate();
  const groupReportCtx = useContext(GroupReportContext);

  const initialData = [
    { quadrant: 'SOUL', no: 9, question: '[First Name] is drawn to people who are visionaries.', score: 2 },
    { quadrant: 'HEART', no: 9, question: "[First Name]'s strong feelings sometimes overwhelm good judgment.", score: 1 },
    { quadrant: 'MIND', no: 9, question: '[First Name] believes the right structures are essential for an effective organization.', score: 3 },
    { quadrant: 'STRENGTH', no: 9, question: '[First Name] likes turning good ideas into action.', score: 4 },
    { quadrant: 'STRENGTH', no: 10, question: "[First Name] takes satisfaction in a hard day's work.", score: 4 },
    { quadrant: 'MIND', no: 10, question: '[First Name] finds satisfaction in developing effective systems.', score: 3 },
    { quadrant: 'SOUL', no: 10, question: "[First Name] finds satisfaction in sharing meaningful stories that impact people's lives.", score: 2 },
    { quadrant: 'HEART', no: 10, question: '[First Name] finds satisfaction in feeling connected to the people they work with.', score: 1 },
  ];


  const [dynamicData, setDynamicData] = useState([...initialData]);

  useEffect(() => {
    if (!apiData) {
      setDynamicData(initialData);
      return;
    }

    const selfScoresMap = new Map();
    if (apiData.bottomQuestions && Array.isArray(apiData.bottomQuestions) && apiData.bottomQuestions.length > 0) {
      apiData.bottomQuestions.forEach(item => {
        const match = item.variable?.match(/^st(\d+)_self_pass([12])$/);
        if (!match) return;

        const rawNo = parseInt(match[1]);
        const passType = match[2];

        let actualScore;
        let actualQuestionNo;

        if (rawNo >= 1 && rawNo <= 10) {
          actualScore = passType === "1" ? 4 : 1;
          actualQuestionNo = rawNo;
        } else if (rawNo >= 11 && rawNo <= 20) {
          actualScore = passType === "1" ? 3 : 2;
          actualQuestionNo = rawNo - 10;
        } else {
          return;
        }

        const key = `${actualQuestionNo}_${actualScore}`;
        selfScoresMap.set(key, actualScore);
      });
    }

    const observersByDesignation = {
      Manager: [],
      DirectReport: [],
      Peer: [],
      Other: []
    };

    if (apiData.memberResults && apiData.memberResults.allMembersData) {
      const membersArray = Object.values(apiData.memberResults.allMembersData);
      membersArray.forEach(member => {
        const designation = member.designation;
        if (designation && designation.includes('Manager')) {
          observersByDesignation.Manager.push(member);
        } else if (designation && designation.includes('Direct Report')) {
          observersByDesignation.DirectReport.push(member);
        } else if (designation && designation.includes('Peer')) {
          observersByDesignation.Peer.push(member);
        } else if (designation && designation.includes('Other')) {
          observersByDesignation.Other.push(member);
        }
      });
    }

    const observerScoresMap = {
      Manager: new Map(),
      DirectReport: new Map(),
      Peer: new Map(),
      Other: new Map()
    };

    Object.keys(observersByDesignation).forEach(designation => {
      observersByDesignation[designation].forEach(member => {
        if (member.bottomQuestions && Array.isArray(member.bottomQuestions) && member.bottomQuestions.length > 0) {
          member.bottomQuestions.forEach(item => {
            const match = item.variable?.match(/^st(\d+)_self_pass([12])$/);
            if (!match) return;

            const rawNo = parseInt(match[1]);
            const passType = match[2];

            let actualScore;
            let actualQuestionNo;

            if (rawNo >= 1 && rawNo <= 10) {
              actualScore = passType === "1" ? 4 : 1;
              actualQuestionNo = rawNo;
            } else if (rawNo >= 11 && rawNo <= 20) {
              actualScore = passType === "1" ? 3 : 2;
              actualQuestionNo = rawNo - 10;
            } else {
              return;
            }

            const key = `${actualQuestionNo}_${actualScore}`;
            observerScoresMap[designation].set(key, actualScore);
          });
        }
      });
    });

    const updatedData = initialData.map(item => {
      const key = `${item.no}_${item.score}`;

      const selfScore = selfScoresMap.get(key);
      const managerScore = observerScoresMap.Manager.get(key);
      const directReportScore = observerScoresMap.DirectReport.get(key);
      const peerScore = observerScoresMap.Peer.get(key);
      const otherScore = observerScoresMap.Other.get(key);

      const allScores = [selfScore, managerScore, directReportScore, peerScore, otherScore]
        .filter(score => score !== undefined && score !== null);

      const average = allScores.length > 0
        ? (allScores.reduce((sum, score) => sum + score, 0) / allScores.length).toFixed(1)
        : '-';

      return {
        ...item,
        self: selfScore || '-',
        manager: managerScore || '-',
        directReport: directReportScore || '-',
        peer: peerScore || '-',
        other: otherScore || '-',
        average: average
      };
    });

    setDynamicData(updatedData);
  }, [apiData]);

  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el?.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el?.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el?.fullName);

  const quadrantScores = { HEART: 1, SOUL: 2, MIND: 3, STRENGTH: 4 };

  const allResults = [];
  dynamicData?.forEach((el) => {
    const res = groupReportCtx?.calculateQuestionScore(
      quadrantScores?.[el.quadrant],
      allVariableSets,
      el.no,
      "360_overview",
      allAssessmentDesignation,
      allAssessmentHash,
      allAssessmentFullName
    );
    if (res?.averageScore !== null) allResults.push(res);
  });

  useEffect(() => {
    if (!allResults.length) return;

    const scoresArray = [];
    dynamicData.forEach((_, index) => {
      const selfScore = groupReportCtx?.getAverageScore("360 Assessment", allResults, index);
      const managerScore = groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index);
      const directReportScore = groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index);
      const peerScore = groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index);
      const otherScore = groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index);
      const averageScore = groupReportCtx?.getObserverAverageScore(allResults, index) ?? "-";

      scoresArray.push([selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore]);
    });

    updateTablevaluesq2Page4(scoresArray);
    logItemsOverviewData({
      pageName: "Quadrant Flow 4",
      items: dynamicData,
      allResults,
      getAverageScore: groupReportCtx.getAverageScore,
    });
  }, [allResults, dynamicData, groupReportCtx, updateTablevaluesq2Page4]);

  const getLabelByIndex = (index) => {
    if (index === 0) return sideLabels[0].label;
    return sideLabels[Math.floor(index / 4)]?.label || "";
  };

  const getStyleByIndex = (index) => {
      if (index === 0) return { top: "12px", height: "50%", backgroundColor: sideLabels[0].bg };
    return { top: "53%", height: "50%", backgroundColor: sideLabels[1].bg };
  };

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="page" style={{ paddingBottom: "0", height: "634px", boxSizing: "border-box", position: "relative" }}>
        <div className="content">
          <div className="table" style={{ position: "relative" }}>
            <div className="tableRow tableHeader" style={{ background: "#245775", color: "#fff", display: "flex", zIndex: "1", position: "relative" }}>
              <div className="cellIndex" style={{ marginLeft: "40px", display: "flex", alignItems: "center" }}>#</div>
              <div className="cellQuadrant" style={{ fontSize: "9px", padding: "5.5px 0px 5.5px 13px", lineHeight: "13px" }}>Quadrant</div>
              <div className="cellLogo"></div>
              <div className="cellQuestion" style={{ marginLeft: "4px", marginRight: "10px" }}>Question</div>
              <div className="cellscore-parent" style={{ display: "flex", marginLeft: "16px" }}>
                <div className="cellScore">S</div>
                <div className="cellScore">M</div>
                <div className="cellScore">D</div>
                <div className="cellScore">P</div>
                <div className="cellScore">O</div>
                <div className="cellScore">A</div>
              </div>
            </div>

            {dynamicData.map((item, index) => {
              const selfScore = Number(groupReportCtx?.getAverageScore("360 Assessment", allResults, index));
              const managerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index));
              const directReportScore = Number(groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index));
              const peerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index));
              const otherScore = Number(groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index));
              const averageScore = Number(groupReportCtx?.getObserverAverageScore(allResults, index));


              // console.log("selfScore,managerScore,directReportScore,peerScore,otherScore",selfScore,managerScore,directReportScore,peerScore,otherScore)

              return (
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "center", padding: "5px 0", }}
                  className={`tableRow ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`}
                >
                  <div className='cellIndex'></div>
                  {index === 0 || index % 4 === 0 ? (
                    <div className="sidelables" style={getStyleByIndex(index)}>{getLabelByIndex(index)}</div>
                  ) : null}
                  <div className="cellIndex" style={{ marginLeft: "30px" }}>{index + 33}.</div>
                  <div className="cellQuadrant" style={{ width: "50px", marginLeft: "11px" }}>{item.quadrant}</div>
                  <div className="cellLogo">{Logo(item.quadrant)}</div>
                  <div className="cellQuestion">{item.question.replace(/\[First Name\]/g, respondentName)}</div>
                  <div className="cellScore-parent" style={{ display: "flex", alignItems: "center", marginLeft: "25px" }}>
                    <div className="cellScore">{typeof selfScore === 'number' && !Number.isNaN(selfScore) ? Number(selfScore).toFixed(1) : '-'}</div>
                    <div className="cellScore">{typeof managerScore === 'number' && !Number.isNaN(managerScore) ? Number(managerScore).toFixed(1) : '-'}</div>
                    <div className="cellScore">{typeof directReportScore === 'number' && !Number.isNaN(directReportScore) ? Number(directReportScore).toFixed(1) : '-'}</div>
                    <div className="cellScore">{typeof peerScore === 'number' && !Number.isNaN(peerScore) ? Number(peerScore).toFixed(1) : '-'}</div>
                    <div className="cellScore">{typeof otherScore === 'number' && !Number.isNaN(otherScore) ? Number(otherScore).toFixed(1) : '-'}</div>
                    <div className="cellScore">{averageScore === 0 || Number.isNaN(averageScore) ? "-" : averageScore.toFixed(1)}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className='details-footer' style={{ position: "absolute", bottom: "4px", width: "100%", boxSizing: "border-box", margin: "0" }}>
          <ul className='details-list' style={{ padding: "4px" }}>
            <li>S - Self</li>
            <li>M - Manager</li>
            <li>D - Direct Report</li>
            <li>P - Peer</li>
            <li>O - Other</li>
            <li>A - Average</li>
          </ul>
        </div>
      </div>
      <FooterPreview reportType={"360 REPORT"} pageNumber={pageNumber} />
    </div>
  );
};

export default QF_ItemFourthPage360;
